export default __webpack_public_path__ + "static/media/BaleWire.719b3a9e.jpg";